import styled, { css, keyframes } from 'styled-components';

const spin = keyframes`
    from { transform: rotate(-90deg); }
    to   { transform: rotate(270deg); }
`;

export const Wrapper = styled.div`
    position: relative;
    margin-right: 8px;
`;

export const IconButton = styled.button`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: none;
    background: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
        background: #f0f2f5;
    }
`;

export const RingSvg = styled.svg<{ $spinning: boolean }>`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);

    ${({ $spinning }) =>
        $spinning &&
        css`
            animation: ${spin} 1.5s linear infinite;
        `}
`;

export const Dropdown = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    z-index: 100;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    min-width: 300px;
    max-width: 360px;
    overflow: hidden;
`;

export const DropdownHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    border-bottom: 1px solid #f0f0f0;
`;

export const DropdownTitle = styled.span`
    font-weight: 600;
    font-size: 13px;
    color: #333;
`;

export const ClearAllButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    color: #999;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 2px;

    &:hover {
        color: #666;
    }
`;

export const TaskList = styled.div`
    max-height: 400px;
    overflow-y: auto;
`;

export const TaskItem = styled.div`
    padding: 10px 14px;

    & + & {
        border-top: 1px solid #f0f0f0;
    }
`;

export const TaskHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
`;

export const TaskTitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const TaskTitle = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: #333;
`;

export const DismissButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    color: #bbb;
    font-size: 12px;
    padding: 0;
    line-height: 1;
    flex-shrink: 0;

    &:hover {
        color: #666;
    }
`;

export const TaskMessage = styled.p`
    margin: 0 0 4px;
    font-size: 12px;
    color: #888;
`;

export const ProgressBar = styled.div`
    height: 3px;
    background: #f0f0f0;
    border-radius: 2px;
    overflow: hidden;
    margin-bottom: 6px;
`;

export const ProgressFill = styled.div`
    height: 100%;
    background: #1890ff;
    border-radius: 2px;
    width: 100%;
    animation: indeterminate 1.5s infinite ease-in-out;

    @keyframes indeterminate {
        0%   { transform: translateX(-100%); }
        100% { transform: translateX(100%); }
    }
`;

export const MetaRow = styled.p`
    margin: 0 0 2px;
    font-size: 12px;
    color: #888;

    strong {
        color: #333;
    }
`;

export const ErrorList = styled.div`
    margin-top: 6px;
    max-height: 120px;
    overflow-y: auto;
`;

export const ErrorTitle = styled.p`
    margin: 0 0 4px;
    font-size: 12px;
    font-weight: 600;
    color: #ff4d4f;
`;

export const ErrorItem = styled.p`
    margin: 0 0 2px;
    font-size: 11px;
    color: #ff4d4f;
`;

export const DownloadButton = styled.button`
    margin-top: 6px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: 1px solid #52c41a;
    border-radius: 4px;
    color: #52c41a;
    font-size: 12px;
    padding: 2px 8px;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;

    &:hover {
        background: #52c41a;
        color: #fff;
    }
`;
